
import { defineComponent, onMounted, ref, computed } from "vue";
import { useI18n } from "vue-i18n/index";
import { useRoute } from "vue-router";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import ClientMainMenuConfig from "@/core/config/ClientMainMenuConfig";
import { Encryption } from "@/core/helpers/Encryption";
import { Storage } from "@/core/helpers/Storage";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);
    const store = useStore();
    const toggleMenu = () => {
      store.dispatch(Actions.TOGGLE_IS_MENU_OPEN);
    };
    onMounted(() => {
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };
    const getMenuItems = computed(() => {
      
      return MainMenuConfig;
    });
    return {
      hasActiveChildren,
      MainMenuConfig,
      ClientMainMenuConfig,
      asideMenuIcons,
      translate,
      Encryption,
      Storage,
      getMenuItems,
      toggleMenu,
    };
  },
});
